import * as React from "react";

const QuestionMark = (props) => (
  <svg
    width={23}
    height={23}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={11.5} cy={11.5} r={11.5} fill="#48B7A7" />
    <path
      d="M10.88 12.701c0-.476.059-.856.177-1.139.118-.282.351-.592.698-.929.351-.34.573-.582.666-.725.144-.218.215-.455.215-.709 0-.336-.084-.592-.252-.768-.165-.179-.408-.268-.73-.268-.309 0-.557.087-.747.263-.187.172-.28.406-.28.703H9.322c.007-.633.222-1.135.645-1.504.426-.368.988-.553 1.686-.553.72 0 1.28.183 1.681.548.405.365.607.876.607 1.53 0 .585-.272 1.16-.816 1.725l-.66.65c-.237.268-.359.66-.366 1.176h-1.22Zm-.091 1.67a.68.68 0 0 1 .198-.51c.133-.132.312-.198.537-.198.23 0 .41.068.543.204.132.132.199.3.199.505a.68.68 0 0 1-.194.494c-.129.132-.311.199-.548.199-.236 0-.418-.067-.547-.2a.69.69 0 0 1-.188-.493Z"
      fill="#fff"
    />
  </svg>
);

export default QuestionMark;
